import { render, staticRenderFns } from "./NuevoBloqueo.vue?vue&type=template&id=0cc1a748&scoped=true&"
import script from "./NuevoBloqueo.vue?vue&type=script&lang=js&"
export * from "./NuevoBloqueo.vue?vue&type=script&lang=js&"
import style0 from "./NuevoBloqueo.vue?vue&type=style&index=0&id=0cc1a748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1a748",
  null
  
)

export default component.exports